module.exports = __webpack_public_path__ + "static/media/regalo.9f313085.svg";